import { Component, Prop, Vue } from 'vue-property-decorator'
import s from '~/utils/s'
import UserListItem from '~/components/page/userProductList/UserListsItem'
import { IUserProductListItemLightweight } from '~/types/api/AidKit';

@Component
export default class UserLists extends Vue {
  @Prop({ required: true, type: String })
  readonly productId!: string;

  inLists: boolean = true
  lists: (string | undefined) [] = []

  async createUserProductList () {
    await s(this.$store).userProductList.createUserProductList()
  }

  getUserListsbyProductId (productId: string) {
    this.lists = s(this.$store).userProductList.userProductLists
      .filter(upl => upl.items.some((item: IUserProductListItemLightweight) => item.productId === productId))
      .map(upl => upl.id)
  }

  render () {
    this.getUserListsbyProductId(this.productId)
    return (
      <div {...{
        class: {
          'user-list-small__wrapper': true
        }
      }}>
        {s(this.$store).userProductList.userProductLists.map((upl) => {
          if (s(this.$store).userProductList.currentListData.userProductList.id !== upl.id && this.$route.name === 'region-userProductList') {
            return (
              <UserListItem {...{
                props: {
                  productId: this.productId,
                  userProductListId: upl.id,
                  userListName: upl.name
                }
              }}/>)
          } else if (this.$route.name !== 'region-userProductList') {
            return (
              <UserListItem {...{
                props: {
                  productId: this.productId,
                  userProductListId: upl.id,
                  userListName: upl.name
                }
              }}/>)
          }
        })}
        <div
          class="user-list-small-item user-list-small__new-list"
          onClick={this.createUserProductList}>Создать новый список
        </div>
      </div>
    )
  }
}
